module.exports = __webpack_public_path__ + "static/img/PL.d9e155d2.jpg";